import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Formik } from 'formik';
import { buildValidationScheme, CustomComponentsContextProvider, useCustomComponentsContext, useSteps, prepareFormStepValues, defaultThemeContextValue, ThemeContextProvider } from '../../utils';
import { FormContainer } from '../FormContainer';
import { useCustomisedFieldMapper } from './utils/useCustomisedFieldMapper';
import { EFormStatus } from '../../constants';
import { EFormEvent, formEventBus, FormEventBusContextProvider } from '../../utils/formEventBus';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormWidget = function FormWidget(props) {
  var initialFormValue = props.initialFormValue,
    fieldMapperExtension = props.fieldMapperExtension,
    _props$validateOnChan = props.validateOnChange,
    validateOnChange = _props$validateOnChan === void 0 ? false : _props$validateOnChan,
    _props$validateOnBlur = props.validateOnBlur,
    validateOnBlur = _props$validateOnBlur === void 0 ? false : _props$validateOnBlur,
    validateOnMount = props.validateOnMount,
    enableReinitialize = props.enableReinitialize,
    theme = props.theme;
  var stepControls = useSteps(props);
  var setNextStep = stepControls.setNextStep,
    setPrevStep = stepControls.setPrevStep,
    question = stepControls.currentStep.question;
  var themeValue = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, defaultThemeContextValue), theme);
  }, [theme]);
  var customComponentsContextValue = useCustomComponentsContext(_objectSpread(_objectSpread({}, props), {}, {
    question: question
  }));
  var validationSchema = React.useMemo(function () {
    return question.validation && buildValidationScheme(question.validation);
  }, [question.validation]);
  var fieldMapper = useCustomisedFieldMapper(fieldMapperExtension);

  /**
   * Инициализируем все поля на шаге при первом рендере формы и при изменении initialFormValue.
   */
  var initialFormValues = React.useMemo(function () {
    return prepareFormStepValues(question.fields, initialFormValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialFormValue]);

  /**
   * В Formik сброс формы реализован так, что сначала будет вызван callback onReset,
   * а уже после изменен стейт формы.
   * setTimeout здесь нужен, чтобы опубликовать событие после изменения стейта формы,
   * поставив выполнение публикации в конец очереди вызовов.
   */
  var onReset = React.useCallback(function () {
    setTimeout(function () {
      formEventBus.emit(EFormEvent.AfterReset);
    });
  }, []);
  return /*#__PURE__*/_jsx(FormEventBusContextProvider, {
    value: formEventBus,
    children: /*#__PURE__*/_jsx(Formik, {
      initialValues: initialFormValues,
      onSubmit: setNextStep,
      validateOnChange: validateOnChange,
      validateOnBlur: validateOnBlur,
      validateOnMount: validateOnMount,
      enableReinitialize: enableReinitialize,
      validationSchema: validationSchema,
      initialStatus: EFormStatus.QuestionEnter,
      onReset: onReset,
      children: /*#__PURE__*/_jsx(ThemeContextProvider, {
        value: themeValue,
        children: /*#__PURE__*/_jsx(CustomComponentsContextProvider, {
          value: customComponentsContextValue,
          children: /*#__PURE__*/_jsx(FormContainer, {
            question: question,
            fieldMapper: fieldMapper,
            setPrevStep: setPrevStep,
            stepControls: stepControls
          })
        })
      })
    })
  });
};
FormWidget.displayName = 'FormWidget';